import { Box, Typography } from '@mui/material';
import useStyles from './index.styles';

import { useAppSelector } from 'hooks/useRedux';
import { workflowExecutionSummary } from 'store/reducer/workflowReducer';

const WorkflowExecutionSummary = () => {
  const classes = useStyles();

  const summaryData: any = useAppSelector(workflowExecutionSummary);

  return (
    <Box className={classes.executionSummaryCont}>
      <Box className={classes.infoContainer}>
        <Typography>Workflow Executions</Typography>
        <Typography color='#00C087' fontSize='1.4rem'>
          {summaryData?.total_workflow_execution}
        </Typography>
      </Box>

      <Box className={classes.infoContainer}>
        <Typography>Communications Sent to</Typography>
        <Typography color='#004357' fontSize='1.4rem'>
          {summaryData?.total_communication}
        </Typography>
        <Typography>customers</Typography>
      </Box>

      <Box className={classes.infoContainer}>
        <Typography>Channel wise</Typography>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Box className={classes.channelSummaryCont}>
            <Typography color='#0F91D2' className={classes.channelSummaryValue}>
              {summaryData?.email_communication}
            </Typography>
            <Typography>Email</Typography>
          </Box>
          <Box className={classes.channelSummaryCont}>
            <Typography color='#BB9B4C' className={classes.channelSummaryValue}>
              {summaryData?.sms_communication}
            </Typography>
            <Typography>SMS</Typography>
          </Box>
          <Box className={classes.channelSummaryCont}>
            <Typography color='#00C087' className={classes.channelSummaryValue}>
              {summaryData?.whatsapp_communication}
            </Typography>
            <Typography>Whatsapp</Typography>
          </Box>
          <Box className={classes.channelSummaryCont}>
            <Typography color='#BB7065' className={classes.channelIvr}>
              {summaryData?.ivr_communication}
            </Typography>
            <Typography>IVR</Typography>
          </Box>
        </Box>
      </Box>

      <Box className={classes.infoContainer}>
        <Typography>Cron vs Real Time</Typography>
        <Box className={classes.cronVsRealCont}>
          <Typography>{summaryData?.cron_execution}</Typography>
          <Typography className={classes.cronVsRealSeparator} />
          <Typography>{summaryData?.realtime_execution}</Typography>
        </Box>
      </Box>
    </Box>
  );
};
export default WorkflowExecutionSummary;
